import { defineStore } from "pinia";
import { isNetworkUnavailable } from "@/composables/network/offlineMode";
import db from "@/db";
import { contributorsConfig } from "@/setup/openApiConfig";
import { RoleApi } from "@socotec.io/contributors-sdk";

const roleApiClient = new RoleApi(contributorsConfig);

export const useRolesStore = defineStore("roles", {
  state: () => ({
    roleList: [],
    totalRoles: 0,
    roleIsLoading: false,
  }),
  actions: {
    async fetchRoles({ filters = {} } = {}) {
      if (isNetworkUnavailable()) return;
      this.roleIsLoading = true;

      const { results, count } = await roleApiClient.list({
        serviceId: filters.service_id,
      });
      const roles = [];

      for (const roleResponse of results) {
        const dexieRoleUuid = await db.models.Role.createOrUpdate(roleResponse);
        if (!dexieRoleUuid) continue;
        roles.push(await db.roles.get({ uuid: dexieRoleUuid }));
      }

      this.roleList = roles;
      this.totalRoles = count;
      this.roleIsLoading = false;

      return roles;
    },
  },
});
